"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmDrawer = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const useResize_1 = require("../hooks/useResize");
exports.SmDrawer = (0, react_1.forwardRef)((_a, ref) => {
    var { className, containerClassName, isOpen, direction = 'right', children, hasBackdrop = true, isScrollable = false, role = 'dialog', onOpen, onClose } = _a, props = __rest(_a, ["className", "containerClassName", "isOpen", "direction", "children", "hasBackdrop", "isScrollable", "role", "onOpen", "onClose"]);
    const screenWidth = (0, useResize_1.useWindowSize)().width;
    const scrollerBlockClassname = 'o-pageScrollBlock';
    const isDesktop = (0, react_1.useMemo)(() => {
        return screenWidth > 767;
    }, [screenWidth]);
    (0, react_1.useMemo)(() => {
        if (isOpen) {
            if (!isScrollable || !isDesktop) {
                document.body.classList.add(scrollerBlockClassname);
            }
            else {
                document.body.classList.remove(scrollerBlockClassname);
            }
            onOpen === null || onOpen === void 0 ? void 0 : onOpen();
        }
        else {
            document.body.classList.remove(scrollerBlockClassname);
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }
    }, [isOpen, isDesktop]);
    const drawerClassnames = (0, classnames_1.default)('c-drawer', className);
    const containerClassnames = (0, classnames_1.default)('c-drawer__container', { '-open': isOpen }, `-${direction}`, containerClassName);
    const backdropClassnames = (0, classnames_1.default)('c-drawer__backdrop');
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("aside", Object.assign({}, props, { ref: ref, className: drawerClassnames, role: role }),
            react_1.default.createElement("div", { className: containerClassnames }, children)),
        hasBackdrop && isOpen && (react_1.default.createElement("div", { className: backdropClassnames, onClick: () => onClose === null || onClose === void 0 ? void 0 : onClose() }))));
});
//# sourceMappingURL=index.js.map